import * as React from 'react';
import { __ } from '../../helpers/TranslationService';
import { IPromotionBanner } from '../../interfaces/IBanner';
import styled from '@emotion/styled';

const PromoBarStyled = styled.div`
    color: ${({ theme }) => theme.text.color.primaryInverse};
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
    padding: 12px 16px;
    background-color: #70ae31;
`;

const PromoBarLink = styled.a`
    color: ${({ theme }) => theme.text.color.primaryInverse};
    text-decoration: underline;
    &:hover {
        color: ${({ theme }) => theme.text.color.primaryInverse};
    }
`;

export const PromoBar = React.forwardRef(
    (props: IPromotionBanner, inputRef: React.LegacyRef<HTMLDivElement>) => {
        const { headline, linkDescription, linkUrl } = props;

        return (
            headline && (
                <PromoBarStyled ref={inputRef}>
                    {headline}{' '}
                    {linkUrl && linkDescription && (
                        <PromoBarLink href={linkUrl}>{linkDescription}</PromoBarLink>
                    )}
                </PromoBarStyled>
            )
        );
    },
);
